<template>
  <div id="page-wrapper">
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ $t('nav.my-report') }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.report') }}</a></li>
          <li class="breadcrumb-item active">{{ $t('nav.my-report') }}</li>
        </ol>
      </div>
    </div>
    <div class="container-fluid">
      <!-- /row -->
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              
              <div class="pull-right">
                <el-input :placeholder="$t('dashboard.filter')" v-model="keywords" class="input-with-select">
                  <el-button slot="append" icon="el-icon-search"></el-button>
                </el-input>
              </div>
            </div>
            <div class="card-body">
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-collapse v-model="activeNames">
                    <el-collapse-item :title="$t('dashboard.report-type.company')" name="1">
                      <el-col :span="4" v-for="r in companyReport">
                      <ReportBox :name="r.name" :icon="r.icon" :url="r.url" :type="r.type" style="margin-top:10px;margin-bottom:10px;" />
                    </el-col>
                    </el-collapse-item>
                    <el-collapse-item :title="$t('dashboard.report-type.hr')" name="5">
                      <el-col :span="4" v-for="r in hrReport">
                      <ReportBox :name="r.name" :icon="r.icon" :url="r.url" :type="r.type" style="margin-top:10px;margin-bottom:10px;" />
                    </el-col>
                    </el-collapse-item>
                    <el-collapse-item :title="$t('dashboard.report-type.team')" name="2">
                      <el-col :span="4" v-for="r in teamReport">
                      <ReportBox :name="r.name" :icon="r.icon" :url="r.url" :type="r.type" style="margin-top:10px;margin-bottom:10px;" />
                    </el-col>
                    </el-collapse-item>
                    <el-collapse-item :title="$t('dashboard.report-type.individual')" name="3">
                      <el-col :span="4" v-for="r in individualReport">
                      <ReportBox :name="r.name" :icon="r.icon" :url="r.url" :type="r.type" style="margin-top:10px;margin-bottom:10px;" />
                    </el-col>
                    </el-collapse-item>
                    <el-collapse-item :title="$t('dashboard.report-type.finance')" name="4">
                      <el-col :span="4" v-for="r in financeReport">
                      <ReportBox :name="r.name" :icon="r.icon" :url="r.url" :type="r.type" style="margin-top:10px;margin-bottom:10px;" />
                    </el-col>
                    </el-collapse-item>
                    <el-collapse-item :title="$t('dashboard.report-type.data')" name="6">
                      <el-col :span="4" v-for="r in dataReport">
                      <ReportBox :name="r.name" :icon="r.icon" :url="r.url" :type="r.type" style="margin-top:10px;margin-bottom:10px;" />
                    </el-col>
                    </el-collapse-item>
                     <el-collapse-item :title="$t('dashboard.report-type.test')" name="6">
                      <el-col :span="4" v-for="r in testReport">
                      <ReportBox :name="r.name" :icon="r.icon" :url="r.url" :type="r.type" style="margin-top:10px;margin-bottom:10px;" />
                    </el-col>
                    </el-collapse-item>
                  </el-collapse>
                </el-col>

                
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
</style>
<script>
import ReportBox from '@/components/dashboard/ReportBox.vue'

export default {
  name: 'ReportList',
  components: {
    ReportBox
  },
  data: function() {
  return {
    report: {},
    keywords: null,
    activeNames: ['1', '2', '3', '4', '5', '6']
  }
  },
  computed: {
    companyReport: function() {
      let k = this.keywords ? this.keywords.toLowerCase() : ''
      if (!this.report.company) return []
      return this.report.company.filter(item => {
    if (item.name.toLowerCase().includes(k)) {
      return item
    }
    })
    },
    hrReport: function() {
      let k = this.keywords ? this.keywords.toLowerCase() : ''
      if (!this.report.hr) return []
      return this.report.hr.filter(item => {
    if (item.name.toLowerCase().includes(k)) {
      return item
    }
    })
    },
    teamReport: function() {
      let k = this.keywords ? this.keywords.toLowerCase() : ''
      if (!this.report.team) return []
      return this.report.team.filter(item => {
    if (item.name.toLowerCase().includes(k)) {
      return item
    }
    })
    },
    financeReport: function() {
      let k = this.keywords ? this.keywords.toLowerCase() : ''
      if (!this.report.finance) return []
      return this.report.finance.filter(item => {
    if (item.name.toLowerCase().includes(k)) {
      return item
    }
    })
    },
    dataReport: function() {
      let k = this.keywords ? this.keywords.toLowerCase() : ''
      if (!this.report.data) return []
      return this.report.data.filter(item => {
    if (item.name.toLowerCase().includes(k)) {
      return item
    }
    })
    },
    testReport: function() {
      let k = this.keywords ? this.keywords.toLowerCase() : ''
      if (!this.report.test) return []
      return this.report.test.filter(item => {
    if (item.name.toLowerCase().includes(k)) {
      return item
    }
    })
    },
    individualReport: function() {
      let k = this.keywords ? this.keywords.toLowerCase() : ''
      if (!this.report.individual) return []
      return this.report.individual.filter(item => {
    if (item.name.toLowerCase().includes(k)) {
      return item
    }
    })
    }
  },
  watch: {
    
  },
  methods: {
    loadData: function() {
      let query = '?userId=' + localStorage.getItem('token'),
          that = this
      this.$http.get(this.API3_PREFIX + 'my_report' + query).then(function (response) {
    that.report = response.data
    console.log(that.report)
      }).catch(function (error) {
    console.log(error)
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>